var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',[_c('canvas',{style:({ width: _vm.width, height: _vm.height }),attrs:{"id":_vm.id,"width":_vm.viewport !== 0 ? '100%' : null}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }